import React, { useState } from 'react';
import Footer from 'components/ui/Footer';

const ContactUs = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState(null); // null | 'sending' | 'sent' | 'error'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      // Placeholder: replace with real API call
      await new Promise((res) => setTimeout(res, 900));
      console.log('Contact form submitted', form);
      setStatus('sent');
      setForm({ name: '', email: '', phone: '', message: '' });
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 flex flex-col">
      <main className="flex-1">
        <section className="bg-white border-b border-gray-100">
          <div className="max-w-7xl mx-auto px-6 py-12 lg:py-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
              <div>
                <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">Contact Us</h1>
                <p className="mt-4 text-gray-600 max-w-xl">
                  Have questions about JustBooked or want a demo? Send us a message — we typically reply within one business day.
                </p>

                <div className="mt-8 space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="p-3 rounded-lg bg-indigo-50 text-indigo-600">
                      <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V8" />
                      </svg>
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-gray-900">Email</div>
                      <div className="text-sm text-gray-600">admin@idevsystems.co.za</div>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="p-3 rounded-lg bg-indigo-50 text-indigo-600">
                      <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5h2l.4 2M7 13h10l1.4-7H6.6L7 13zM7 13l-1 7h12l-1-7M16 8a2 2 0 11-4 0" />
                      </svg>
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-gray-900">Phone</div>
                      <div className="text-sm text-gray-600">+27 (65) 947-9428</div>
                    </div>
                  </div>

                  {/* <div className="flex items-start gap-4">
                    <div className="p-3 rounded-lg bg-indigo-50 text-indigo-600">
                      <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5V4H2v16h5M9 10h6M9 14h6" />
                      </svg>
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-gray-900">Office</div>
                      <div className="text-sm text-gray-600">123 Clean St, Suite 200, Washville, CA</div>
                    </div>
                  </div> */}
                </div>
              </div>

              <div>
                <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-6">
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <label className="block">
                        <span className="text-sm font-medium text-gray-700">Name</span>
                        <input
                          name="name"
                          value={form.name}
                          onChange={handleChange}
                          required
                          className="mt-1 block w-full rounded-md border-gray-200 bg-gray-50 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          placeholder="Your name"
                        />
                      </label>

                      <label className="block">
                        <span className="text-sm font-medium text-gray-700">Email</span>
                        <input
                          name="email"
                          type="email"
                          value={form.email}
                          onChange={handleChange}
                          required
                          className="mt-1 block w-full rounded-md border-gray-200 bg-gray-50 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          placeholder="you@company.com"
                        />
                      </label>
                    </div>

                    <label className="block">
                      <span className="text-sm font-medium text-gray-700">Phone (optional)</span>
                      <input
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-200 bg-gray-50 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="+1 (555) 987-6543"
                      />
                    </label>

                    <label className="block">
                      <span className="text-sm font-medium text-gray-700">Message</span>
                      <textarea
                        name="message"
                        value={form.message}
                        onChange={handleChange}
                        required
                        rows="5"
                        className="mt-1 block w-full rounded-md border-gray-200 bg-gray-50 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="Tell us how we can help..."
                      />
                    </label>

                    <div className="flex items-center justify-between gap-4">
                      <button
                        type="submit"
                        disabled={status === 'sending'}
                        className="inline-flex items-center justify-center px-5 py-2 rounded-full bg-indigo-600 text-white text-sm font-medium shadow hover:bg-indigo-700 disabled:opacity-60"
                      >
                        {status === 'sending' ? 'Sending...' : 'Send Message'}
                      </button>

                      <div className="text-sm text-gray-600">
                        {status === 'sent' && <span className="text-green-600 font-medium">Message sent — we will reply shortly.</span>}
                        {status === 'error' && <span className="text-red-600 font-medium">Something went wrong. Try again.</span>}
                      </div>
                    </div>
                  </form>
                </div>

                <div className="mt-6 text-sm text-gray-500">
                  Or reach us directly at <a href="mailto:admin@idevsystems.co.za" className="text-indigo-600 hover:underline">admin@idevsystems.co.za</a>
                </div>
              </div>
            </div>

            {/* <div className="mt-10">
              <h3 className="text-lg font-semibold text-gray-900">Location</h3>
              <p className="mt-2 text-sm text-gray-600">Visit our office or schedule an on-site demo.</p>

              <div className="mt-4 h-56 rounded-lg overflow-hidden border border-gray-100">
           
                <div className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-400">
                  Map placeholder
                </div>
              </div>
            </div> */}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ContactUs;